module.exports = __webpack_public_path__ + "img/ca.518fb22b.svg";